module.exports = __webpack_public_path__ + "img/14.8d1abf96.png";